import shortid from 'shortid';

const operationEq = (answerValue, conditionValue) => {
  return 'value' in answerValue
    ? answerValue.value === conditionValue
    : Object.values(answerValue).find(({ value }) => value === conditionValue);
};

export const validateCondition = (
  fieldName,
  { __operation, value, operands },
  formValues,
  relativeAnswers
) => {
  const answerValue = formValues[fieldName] || relativeAnswers[fieldName];
  if (!answerValue) {
    return false;
  }
  switch (__operation) {
    case 'in': {
      return value.includes(answerValue.value);
    }
    case 'eq': {
      return operationEq(answerValue, value);
    }
    case 'and': {
      return;
    }
    case 'or': {
      return;
    }
    default:
      return 'exception';
  }
};

export const findQuestion = (slug, arr = [], parent) => {
  let result = null;

  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (item.slug === slug) {
      result = { ...item, parent: parent };
      break;
    }
    if (item.children.length) {
      result = findQuestion(slug, item.children, item);
      if (result) {
        break;
      }
    }
  }

  return result;
};

export const addQuestionChild = (questions, child) => {
  return questions.map((quest) => {
    const updated = { ...quest };
    if (quest.slug === child.parent.slug) {
      updated.children = [
        ...updated.children,
        { ...child, uid: shortid.generate() },
      ];
    } else if (quest.children) {
      updated.children = addQuestionChild(updated.children, child);
    }
    return updated;
  });
};

export const restoreQuestionChild = (questions, child) => {
  return questions.map((quest) => {
    const updated = { ...quest };
    if (quest.slug === child.parent.slug) {
      updated.children = [...updated.children, child];
    } else if (quest.children) {
      updated.children = restoreQuestionChild(updated.children, child);
    }
    return updated;
  });
};

export const deleteQuestionChild = (questions, parentSlug, childUid) => {
  return questions.map((quest) => {
    const updated = { ...quest };
    if (quest.slug === parentSlug) {
      updated.children = updated.children.filter(
        (quest) => quest.uid !== childUid
      );
    } else if (quest.children) {
      updated.children = deleteQuestionChild(
        updated.children,
        parentSlug,
        childUid
      );
    }
    return updated;
  });
};

export const getDefaultValues = (options) => {
  return options.reduce((acc, { key, type }) => {
    acc[key] = type === 'checkbox' ? false : '';
    return acc;
  }, {});
};
